import { ElementType } from "react";
import AnnouncementIcon from "../assets/icons/sidebar/AnnouncementIcon";
import AttendanceIcon from "../assets/icons/sidebar/AttendanceIcon";
import DashboardIcon from "../assets/icons/sidebar/DashboardIcon";
import DevicesIcon from "../assets/icons/sidebar/DevicesIcon";
import EmployeesIcon from "../assets/icons/sidebar/EmployeesIcon";
import EmployeeTrackingIcon from "../assets/icons/sidebar/EmployeeTrackingIcon";
import ExpenseIcon from "../assets/icons/sidebar/ExpenseIcon";
import LeaveIcon from "../assets/icons/sidebar/LeaveIcon";
import PayrollIcon from "../assets/icons/sidebar/PayrollIcon";
// import PerformanceIcon from "../assets/icons/sidebar/PerformanceIcon";
import ProfileIcon from "../assets/icons/sidebar/ProfileIcon";
import ReportIcon from "../assets/icons/sidebar/ReportIcon";
import SettingsIcon from "../assets/icons/sidebar/SettingsIcon";
import SupportTicketsIcon from "../assets/icons/sidebar/SupportTicketsIcon";
import VisitIcon from "../assets/icons/sidebar/VisitIcon";
import { Role } from "../types/common";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: Role[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const AllSidebarMenu: MenuTypes[] = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: DashboardIcon,
    role: ["Admin", "Manager"],
  },
  {
    name: "Profile",
    path: "/admin/user-dashboard",
    icon: ProfileIcon,
    role: ["Manager", "Employee"],
  },
  {
    name: "Support Tickets",
    path: "/admin/my-support-tickets",
    icon: SupportTicketsIcon,
    role: ["Manager", "Employee"],
  },
  {
    name: "Employees",
    path: "/admin/employees",
    icon: EmployeesIcon,
    role: ["Admin", "Manager"],
  },

  {
    name: "Devices",
    path: "/admin/devices",
    icon: DevicesIcon,
    role: ["Admin"],
  },

  {
    name: "Leave",
    path: "/admin/leave",
    icon: LeaveIcon,
    role: ["Admin", "Manager"],
    children: [
      {
        name: "Leave Requests",
        path: "/admin/leave/leave-requests",
        role: ["Admin", "Manager"],
      },
      {
        name: "Leave Balance",
        path: "/admin/leave/leave-balance",
        role: ["Admin", "Manager"],
      },
    ],
  },
  {
    name: "Attendance",
    path: "/admin/attendance",
    icon: AttendanceIcon,
    role: ["Admin", "Manager"],
    children: [
      {
        name: "Daily Attendance",
        path: "/admin/attendance/daily-attendance",
        role: ["Admin", "Manager"],
      },
      {
        name: "Custom Attendance",
        path: "/admin/attendance/custom-attendance",
        role: ["Admin", "Manager"],
      },
      {
        name: "Shift Management",
        path: "/admin/attendance/shift-management",
        role: ["Admin", "Manager"],
      },
    ],
  },
  {
    name: "Expense",
    path: "/admin/expense",
    icon: ExpenseIcon,
    role: ["Admin", "Manager"],
  },
  {
    name: "Visit",
    path: "/admin/visit",
    icon: VisitIcon,
    role: ["Admin"],
  },
  {
    name: "Employee Tracking",
    path: "/admin/employee-tracking",
    icon: EmployeeTrackingIcon,
    role: ["Admin"],
  },

  // TODO: hide for keycloak production
  // {
  //   name: "KPI Setup",
  //   path: "/admin/kpi-setup",
  //   icon: PerformanceIcon,
  //   role: ["Admin", "Manager", "Employee"],
  //   children: [
  //     {
  //       name: "Open KPI Setup",
  //       path: "/admin/kpi-setup/open-kpi-setup",
  //       role: ["Admin"],
  //     },
  //     {
  //       name: "KPI Setup Report",
  //       path: "/admin/kpi-setup/kpi-setup-report",
  //       role: ["Admin"],
  //     },
  //     // {
  //     //   name: "Open KPI Setup Request",
  //     //   path: "/admin/kpi-setup/open-kpi-setup-request",
  //     //   role: ["Admin"],
  //     // },
  //     {
  //       name: "Appraisal Report",
  //       path: "/admin/kpi-setup/appraisal-report",
  //       role: ["Admin"],
  //     },
  //     {
  //       name: "Own KPI List",
  //       path: "/admin/kpi-setup/own-kpi",
  //       role: ["Manager", "Employee"],
  //     },
  //     {
  //       name: "Own Appraisals",
  //       path: "/admin/kpi-setup/own-appraisals",
  //       role: ["Manager", "Employee"],
  //     },
  //     {
  //       name: "Team Member KPI",
  //       path: "/admin/kpi-setup/team-member-kpi",
  //       role: ["Manager"],
  //     },
  //     {
  //       name: "Team Member Appraisal",
  //       path: "/admin/kpi-setup/team-member-appraisal",
  //       role: ["Manager"],
  //     },
  //   ],
  // },
  {
    name: "Payroll",
    path: "/admin/payroll",
    icon: PayrollIcon,
    role: ["Admin"],
    // badge: "beta",
  },
  {
    name: "Payroll",
    path: "/admin/payroll/variable-salary",
    icon: PayrollIcon,
    role: ["Manager"],
    // badge: "beta",
  },
  {
    name: "Settings",
    path: "/admin/settings",
    icon: SettingsIcon,
    role: ["Admin", "Manager"],
    children: [
      {
        name: "Leave",
        path: "/admin/settings/leave",
        role: ["Admin"],
      },
      {
        name: "Approval",
        path: "/admin/settings/approval",
        role: ["Admin"],
      },
      {
        name: "Payroll",
        path: "/admin/settings/payroll",
        role: ["Admin"],
      },
      {
        name: "Office Settings",
        path: "/admin/settings/office-settings",
        role: ["Admin"],
      },
      {
        name: "Visit Settings",
        path: "/admin/settings/visit-settings",
        role: ["Admin"],
      },
      {
        name: "Employee Tracking",
        path: "/admin/settings/employee-tracking",
        role: ["Admin", "Manager"],
      },
      {
        name: "Emp. Custom Fields",
        path: "/admin/settings/employee-custom-fields",
        role: ["Admin"],
      },
      {
        name: "Department",
        path: "/admin/settings/department",
        role: ["Admin"],
      },
      {
        name: "Designation",
        path: "/admin/settings/designation",
        role: ["Admin"],
      },
      {
        name: "Work Station",
        path: "/admin/settings/work-station",
        role: ["Admin"],
      },
      {
        name: "Expense Unit",
        path: "/admin/settings/expense-unit",
        role: ["Admin"],
      },
      {
        name: "Config Device API Token",
        path: "/admin/settings/config-device-api-token",
        role: ["Admin"],
      },
    ],
  },
  {
    name: "Announcement",
    path: "/admin/announcement",
    icon: AnnouncementIcon,
    role: ["Admin", "Manager"],
  },
  {
    name: "Reports",
    path: "/admin/reports",
    icon: ReportIcon,
    role: ["Admin", "Manager"],
  },
  {
    name: "Support Tickets",
    path: "/admin/support-tickets",
    icon: SupportTicketsIcon,
    role: ["Admin"],
  },
  // {
  //   name: "TopUp",
  //   path: "",
  //   icon: SupportTicketsIcon,
  //   role: ["Admin"],
  // },
  {
    name: "Task Queue",
    path: "/admin/task-queue",
    icon: ReportIcon,
    role: ["Admin"],
  },

  // {
  //   name: "Promotion",
  //   path: "/admin/promotion",
  //   icon: PromotionIcon,
  //   role: ["Manager", "Employee"],
  // },
  // {
  //   name: "Performance Management",
  //   path: "/admin/performance-management",
  //   icon: PerformanceIcon,
  //   role: ["Manager", "Employee"],
  // },
];

export default AllSidebarMenu;
